import { render, staticRenderFns } from "./BowActivitiesList.vue?vue&type=template&id=3679187f&"
import script from "./BowActivitiesList.vue?vue&type=script&lang=js&"
export * from "./BowActivitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowMedia: require('/workspace/components/molecules/BowMedia/BowMedia.vue').default})
